import './UnauthorizedPage.css';

export default function UnauthorizedPage() {

  return (
    <>
      <p className='center'>You are not authorized to send notifications.</p>
    </>
  );
}